var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.235 3.48071C11.102 2.36502 10.1525 1.5 9.00098 1.5C7.84947 1.5 6.9 2.36502 6.76693 3.48071C4.88993 4.3316 3.58431 6.22166 3.58431 8.41667V12.1799L2.33144 14.662C2.07964 15.1609 2.4422 15.75 3.00098 15.75H6.87901C7.18788 16.6239 8.02131 17.25 9.00098 17.25C9.98064 17.25 10.8141 16.6239 11.1229 15.75H15.001C15.5598 15.75 15.9223 15.1609 15.6705 14.662L14.4176 12.1799V8.41667C14.4176 6.22166 13.112 4.3316 11.235 3.48071ZM12.9981 12.6964L13.7823 14.25H4.21967L5.00385 12.6964C5.05675 12.5916 5.08431 12.4759 5.08431 12.3585V8.41667C5.08431 6.25355 6.83786 4.5 9.00098 4.5C11.1641 4.5 12.9176 6.25355 12.9176 8.41667V12.3585C12.9176 12.4759 12.9452 12.5916 12.9981 12.6964Z",
    fill: "#A3A3C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.b968cd0f2d4dde8f8179f6bd3a8be5ae.svg";
export { ForwardRef as ReactComponent };